import { api } from "./api";
import type {
    Blog,
    BlogListResponse,
    BlogResponse,
    BlogRevision,
    BlogRevisionListResponse,
    CreateBlogParams,
    UpdateBlogParams,
} from "../types/blog";

type ListBlogsQueryParams = {
    status?: "private" | "draft" | "public";
};

export const blogService = {
    getAll: async (params?: ListBlogsQueryParams): Promise<Blog[]> => {
        let path = "/blogs";
        if (params?.status) {
            path += `?status=${params.status}`;
        }

        const response = await api.get<BlogListResponse>(path);
        return response.data;
    },

    getById: async (id: string | number): Promise<Blog> => {
        const response = await api.get<BlogResponse>(`/blogs/${id}`);
        return response.data;
    },

    create: async (b: CreateBlogParams): Promise<Blog> => {
        const response = await api.post<BlogResponse>("/blogs", { blog: b });
        return response.data;
    },

    update: async (id: string | number, b: UpdateBlogParams): Promise<Blog> => {
        const response = await api.put<BlogResponse>(`/blogs/${id}`, { blog: b });
        return response.data;
    },

    updateContent: async (id: string | number, content: string): Promise<Blog> => {
        const response = await api.put<BlogResponse>(`/blogs/${id}/content`, { content });
        return response.data;
    },

    listRevisions: async (id: string | number): Promise<BlogRevision[]> => {
        const response = await api.get<BlogRevisionListResponse>(`/blogs/${id}/revisions`);
        return response.data;
    },
};
